module.exports = __webpack_public_path__ + "static/media/manage-header-q.a9373bb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/manage-header-q.png
// module id = 2050
// module chunks = 6